module.exports = __webpack_public_path__ + "img/tp-toggle-on.1fc64622.svg";